export default "__VITE_ASSET__XiDCwWky__"